import { UI_LOADING_END } from 'actions/Types';

const stopUILoading = key => {
  return dispatch => {
    const action = {
      type: UI_LOADING_END,
      key
    };
    dispatch(action);
  };
};

export default stopUILoading;
